import { ColumnFilter } from "src/base-components/ColumnFilter";
import { useFilter } from "src/base-components/tableColumnFilters/useFilters";

type BooleanFilterProps = {
  property: string;
  displayName: string;
  dataLoc?: string;
};

export const BooleanFilter: React.FC<BooleanFilterProps> = ({
  property,
  displayName,
  dataLoc,
}) => {
  const { filters, update, apply, reset, isFiltering, isApplied } = useFilter(
    property,
    [
      {
        key: property,
        operator: "eq",
        values: [],
      },
    ],
  );

  const filter = filters[0];

  return (
    <ColumnFilter
      dataLoc={dataLoc}
      description={`Filter by ${displayName}`}
      elements={[
        { key: "true", value: "True" },
        { key: "false", value: "False" },
      ]}
      isApplied={isApplied()}
      isFiltering={isFiltering({ key: property })}
      placement="bottom start"
      selected={filter.values[0] as "true" | "false"}
      onApply={apply}
      onResetRequest={() => reset()}
      onSelect={(value, event) => {
        event.stopPropagation();
        update([
          {
            ...filter,
            values: filter.values[0] === value ? [] : [value],
          },
        ]);
      }}
    />
  );
};
